import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

import Box from '@mui/material/Box';
import Image from 'components/Image';
import GradientOverlay from 'bento-ordering/base/ui_components/GradientOverlay';
import { getImageWithHeight } from 'bento-ordering/utils/images';

const ImageContainer = styled(Box)({
  position: 'relative',
  width: '100%',
  height: '260px'
});

function MenuItemImage({ url, focalPointX, focalPointY }) {
  const resizedImage = getImageWithHeight(url, 520);

  return (
    <ImageContainer>
      <Image
        gradientId="menu-item-image"
        src={resizedImage}
        focalPointX={focalPointX}
        focalPointY={focalPointY}
      />
      <GradientOverlay height="110px" />
    </ImageContainer>
  );
}

MenuItemImage.propTypes = {
  url: PropTypes.string,
  focalPointX: PropTypes.number,
  focalPointY: PropTypes.number
};

export default MenuItemImage;
